import { PIN_NUMBER_ARRAY } from "@/consts";

interface IProps {
    onClickNumberBtn: (number: string) => void;
    OnClickDeleteBtn: () => void;
    onClickAllClearBtn: () => void;
}

const PinNumberPad = ({onClickNumberBtn, OnClickDeleteBtn, onClickAllClearBtn}: IProps) => {
    return (
        <div className="keypad">
                    {PIN_NUMBER_ARRAY.map((num) => (
                        <div 
                            key={num} 
                            className="key num fw-b"
                            onClick={() => onClickNumberBtn(num.toString())}
                        >
                            {num}
                        </div>
                    ))}
                    <div 
                        className="key body-n-n fw-b"
                        onClick={onClickAllClearBtn}
                    >
                        전체삭제
                    </div>
                    <div 
                        className="key num fw-b"
                        onClick={() => onClickNumberBtn('0')}
                    >
                        0
                    </div>
                    <div 
                        className="key body-l-n delete"
                        onClick={OnClickDeleteBtn}
                    >
                        &#x232b;
                    </div>
                </div>
    )
}

export default PinNumberPad;